"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Tabs_1 = __importDefault(require("@web/common/Tabs"));
(() => {
    const tabsElement = document.getElementById('payment-history-tabs');
    if (tabsElement) {
        (0, Tabs_1.default)(tabsElement);
    }
})();
